import React, { useContext } from "react";
import { Context } from "../../../Utility/ContextManager";
import { formatDate } from "../../../Utility/";
import axios from "axios";
import { useconfirmAlert } from "../../../Utility/Confirmation";

function DocumentList({ deleteDocument, size }) {
  const { propertyUnitDocuments } = useContext(Context);

  const downloadImage = (selectedDocument) => {
    axios({ url: selectedDocument.path, method: "GET", responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", selectedDocument.document_name);
      document.body.appendChild(link);
      link.click();
    });
  };

  const onDelete = (selectedDocument) => {
    useconfirmAlert({ onConfirm: () => deleteDocument(selectedDocument.id) });
  };

  return (
    <div className="table-responsive" data-simplebar style={{ maxHeight: size ? `${size}px` : "200px" }}>
      <table className="table document-list">
        <thead>
          <tr>
            <th width={25}>#</th>
            <th>Description</th>
            <th>Name</th>
            <th>Type</th>
            <th>Upload Date</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {propertyUnitDocuments?.map((document, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{document?.description}</td>
              <td>{document?.document_name}</td>
              <td>{document?.document_name.split(".").pop()}</td>
              <td>{formatDate(document?.created_at)}</td>
              <td align="right">
                <a target="_blank" href={document.path}>
                  Open
                </a>
                <a className="cursor-pointer" onClick={() => downloadImage(document)}>
                  <img src={require("../../../assets/images/download-icon.svg").default} alt="" />
                </a>
                <a className="cursor-pointer" data-cy={`deletefile${index}`} onClick={() => onDelete(document)}>
                  <img src={require("../../../assets/images/delete.svg").default} alt="" />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DocumentList;
